import { Filter } from "./filter";

export class Archived extends Filter {
  constructor() {
    super("archived");
  }
}
